import './_custom-field.scss'
import React from 'react';
import { ControlLabel, FormControl, FormGroup } from 'react-bootstrap';
import _ from 'lodash';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const CustomField = ({ value, list, field_type, label, name, onChange, refill }) => {
  const onChangeField = (fieldKey, fieldValue) => {
    onChange(fieldKey, fieldValue);
  };

  const uniqueName = refill ? `refill_provider_service_params[${name}]` : `custom_fields[${name}]`;

  return (
    <FormGroup>
      <ControlLabel
        htmlFor={uniqueName}
        className={classNames({
          'service-label__type-text': field_type === 'text',
        })}
      >
        {label}
      </ControlLabel>
      {(() => {
        switch (field_type) {
        case 'text':
          return (
            <FormControl
              type="text"
              id={uniqueName}
              name={uniqueName}
              key={uniqueName}
              value={value || ''}
              onChange={(e) => onChangeField(name, e.target.value)}
            />
          )
        case 'select':
          const isList = list && _.isObject(list);
          if (isList) {
            return (
              <select
                name={uniqueName}
                id={uniqueName}
                className="form-control"
                value={value}
                key={uniqueName}
                onChange={(e) => onChangeField(name, e.target.value)}
              >
                {Object.keys(list).map((listKey) => {
                  const optionName = list[listKey];
                  return <option value={listKey} key={listKey}>{optionName}</option>
                })}
              </select>
            )
          }
          return null;
        default:
          return null;
        }
      })()}
    </FormGroup>
  );
};

CustomField.propTypes = {
  value: PropTypes.string,
  list: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  field_type: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  refill: PropTypes.bool,
}

export default CustomField;
